import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function AdminPayoutsPage() {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    api.get("/admin/payouts").then((r) => setRows(r.data));
  }, []);
  return (
    <div className="p-6 md:p-8" data-testid="admin-payouts">
      <h1 className="font-display text-2xl font-bold text-[#0A1628] mb-6">Payouts</h1>
      <div className="bg-white border border-[#E5E7EB] rounded-2xl overflow-hidden soft-shadow">
        <table className="w-full text-sm">
          <thead className="bg-[#F9FAFB] text-xs uppercase tracking-wider text-[#9CA3AF]">
            <tr>
              <th className="text-left px-5 py-3 font-semibold">Reference</th>
              <th className="text-left px-5 py-3 font-semibold">Method</th>
              <th className="text-left px-5 py-3 font-semibold">Handle</th>
              <th className="text-right px-5 py-3 font-semibold">Amount</th>
              <th className="text-left px-5 py-3 font-semibold">Transaction</th>
              <th className="text-left px-5 py-3 font-semibold">When</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((p) => (
              <tr key={p.id} className="border-t border-[#F3F4F6]" data-testid={`payout-${p.transaction_id}`}>
                <td className="px-5 py-3 font-mono-display font-semibold text-[#0A1628]">{p.reference}</td>
                <td className="px-5 py-3 uppercase text-xs text-[#0A1628]">{p.method}</td>
                <td className="px-5 py-3 text-xs font-mono-display text-[#4B5563]">{p.handle}</td>
                <td className="px-5 py-3 text-right font-mono-display font-bold text-[#0A1628]">${p.amount.toFixed(2)}</td>
                <td className="px-5 py-3 text-xs font-mono-display text-[#4B5563]">{p.transaction_id}</td>
                <td className="px-5 py-3 text-xs text-[#9CA3AF] font-mono-display">{new Date(p.timestamp).toLocaleString()}</td>
              </tr>
            ))}
            {rows.length === 0 && (
              <tr><td colSpan={6} className="py-12 text-center text-[#9CA3AF]">No payouts yet.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
